import Logo from '@ux/logo';
import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';
import { IntlProvider } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import ContactUs from './contact-us';
import LoginLogout from './login-logout';
import Version from './version';
import Navigation from './navigation';
import { breakpoints } from './enums';

class NavigationHelp extends NamespaceConsumer {

  componentDidMount() {
    this.breakpoint(...breakpoints);
  }

  componentWillUnmount() {
    this.breakup();
  }

  static getDerivedStateFromProps(props) {
    return {
      emptyNav: props.navigation.every(navItem => !navItem.caption)
    };
  }

  renderLogo(renderMobile) {
    const props = this.props;
    const { isMobile } = props;

    const logoClasses = this.namespace('logo-text', 'logo-gd');
    const outsideLogoClasses = this.namespace('logo', 'brand-logo');

    const wrapperClass = renderMobile ? 'nav-left-wrap-full' : 'nav-left-wrap';
    let homeUrl = '';
    if (props.urls && props.urls.home && props.urls.home.href) {
      homeUrl = props.urls.home.href;
    }

    return (
      <div className={ this.namespace(wrapperClass) }>
        <Logo
          className={ outsideLogoClasses }
          country={ props.countryName }
          href={ homeUrl }
          market={ props.market }
          messages={ props.messages }
          logos={ props.logos }
          showCountryNameOnLogo={ false }
          spanClass={ logoClasses }
          urlArgs={ props.urlArgs }
          isMobile={ isMobile }
          includeGDHead={ false }
        />
        <div className={ this.namespace('version', 'hidden-sm-down') }>
          <Version value={ props.version } />
        </div>
      </div>
    );
  }

  renderNav(renderMobile) {
    const props = this.props;
    const className = renderMobile ? 'nav-help-set' : 'nav-help-set-full';
    return (
      <div className={ this.namespace(className) }>
        <div className={ this.namespace('nav-help-separator', 'hidden-md-down') } />
        <Navigation
          items={ props.navigation }
          renderMobile={ renderMobile }
          urls={ props.urls }
          loggedIn={ props.loggedIn }
          sso={ props.sso }
        />
      </div>
    );
  }

  render() {
    const props = this.props;
    const state = this.state;
    const isNotDesktop = ['mobile', 'phablet', 'tablet'].indexOf(state.breakpoint) !== -1;
    const renderMobile = isNotDesktop && !state.emptyNav && props.renderMobile !== false;
    const renderNav = !(typeof window === 'undefined' || state.emptyNav);

    return (
      <IntlProvider locale={ props.market } messages={ props.messages }>
        <nav className={ this.namespace('nav-help', 'clearfix') }>
          <div className={ this.namespace('container-fluid') }>
            <div className={ this.namespace('nav-help-left-container') }>
              { !renderMobile && this.renderLogo(renderMobile) }
              { renderNav && this.renderNav(renderMobile) }
              { renderMobile && this.renderLogo(renderMobile) }
            </div>
            <div className={ this.namespace('nav-help-right-container') }>
              <ContactUs
                urls={ props.urls }
                app={ props.app }
                currentHref={ props.currentHref } />
              <LoginLogout
                displayName={ props.displayName }
                isPro={ props.isPro }
                loggedIn={ props.loggedIn }
                market={ props.market }
                messages={ props.messages }
                urlArgs={ props.urlArgs }
                urls={ props.urls }
                sso={ props.sso }
              />
            </div>
          </div>
        </nav>
      </IntlProvider>);
  }
}

NavigationHelp.propTypes = {
  ...NamespaceShape,
  market: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired
};

export default withNamespace(NavigationHelp);
